export * from './wizard.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/wizard/index.ts